import React from 'react'
import { connect } from 'react-redux'
import { Grid, Segment } from 'semantic-ui-react'
import { date as dateFormatter } from 'loankeeper-common/helpers/formatters'
//@ts-ignore
import { FlexTableChild, TableContainer, GridContainer, FlexContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
//@ts-ignore
import LKModal, { actions as LKModalActions } from 'shared/LKModal'
import AddTag, { TagAddTrigger } from '../../TagAdd'
import { actions as DetailsContainerActions } from '../../DetailsContainer'
import { formName } from '../constants'
import { translateCmd, translateLKMessage } from '../helpers'
import { TagData, TagsProps } from '../types'
import { deleteTag } from 'src/store/client'

const config = {
  gridIdentity: {
    formName,
    objectName: 'dbgrd_tags',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnConfigs: {
    TagDate: {
      valueFormatter: ({ value }) => dateFormatter(value),
    },
  },
}

//@ts-ignore
@connect(undefined, (dispatch: AppDispatch, { ID, hash }) => ({
  openConfirmation: (TagID: number) => {
    dispatch(LKModalActions.openConfirmation('DeleteClientTag', { TagID }))
  },

  deleteTag: async (TagID: number, setLoading: (loading: boolean) => void) => {
    setLoading(true)

    try {
      // await Client.deleteTag({ ClientID: ID, HashSum_ClientID_: hash, ID: TagID })

      //UPDATED API REQUEST client_oper_api page: tagdelete
      const response = await dispatch(
        deleteTag({
          ClientID: ID,
          HashSum_ClientID_: hash,
          ID: TagID,
        }),
      )

      if (!deleteTag.fulfilled.match(response)) {
        throw { Error: { Message: response.payload } }
      }
      dispatch(DetailsContainerActions.fetchPage({ type: 'Client', ID, hash, page: 'tags' }))
    } catch (error) {
      dispatch(LKModalActions.openError(translateLKMessage(error.Error.Message || error.Error.Text)))
    } finally {
      setLoading(false)
    }
  },
}))
class Tags extends React.Component<TagsProps> {
  static defaultProps = {
    data: [],
  }

  state = { loading: false }

  getContextMenu = ({
    node: {
      data: { ID },
    },
  }: {
    node: {
      data: TagData
    }
  }) => [
    {
      name: translateCmd('delete_tag'),
      icon: 'delete',
      action: () => this.props.openConfirmation(ID),
      permissionKey: 'CLIENT_DELETE_TAG',
    },
  ]

  setLoading = (loading: boolean) => this.setState({ loading })

  handleDeleteTagConfirm = ({ TagID }: { TagID: number }) => {
    this.props.deleteTag(TagID, this.setLoading)
  }

  render() {
    const { data, instanceName, ID, hash } = this.props

    return (
      <FlexContainer>
        <LKModal.Confirmation
          name="DeleteClientTag"
          onConfirm={this.handleDeleteTagConfirm}
          loading={this.state.loading}
        />

        <FlexTableChild>
          <TableContainer>
            <LKGrid rowData={data} getContextMenuItems={this.getContextMenu} {...config} instanceName={instanceName} />
          </TableContainer>
        </FlexTableChild>

        <Segment>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column>
                  <TagAddTrigger permission="CLIENT_ADD_TAG">{translateCmd('add_tag')}</TagAddTrigger>

                  <AddTag type="Client" addedTags={data} ID={ID} hash={hash} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Segment>
      </FlexContainer>
    )
  }
}

export default Tags
